import { SVGProps, Ref, forwardRef } from 'react';

export const GiftFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.896 1.753c.423.339.797.78 1.104 1.314a4.6 4.6 0 0 1 1.104-1.314c1.213-.97 2.851-1.06 3.977.066 1.19 1.19 1.018 2.95-.109 4.181H21.5c2.188 0 2.5.313 2.5 2.5 0 2.188-.312 2.5-2.5 2.5h-8.6V7.8h-1.8V11H2.5C.312 11 0 10.688 0 8.5 0 6.313.312 6 2.5 6h4.528c-1.126-1.231-1.3-2.99-.109-4.18C8.045.692 9.683.782 10.896 1.752M9.77 3.158c-.64-.511-1.224-.421-1.58-.066-.354.355-.444.94.067 1.58.434.542 1.327 1.102 2.788 1.274-.172-1.461-.732-2.353-1.275-2.788m4.458 0c.64-.511 1.224-.421 1.58-.066.354.355.444.94-.067 1.58-.435.542-1.327 1.102-2.788 1.274.172-1.461.732-2.353 1.275-2.788M2 12.8h9.1v10.197H9.333c-5.386 0-7.256-1.759-7.33-6.997H2zm10.9 0v10.197h1.767c5.386 0 7.256-1.759 7.33-6.997H22v-3.2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
GiftFilledSize24Glyph.displayName = 'GiftFilledSize24Glyph';
